module.exports = "<span>{{ $ctrl.email }}</span> ";